import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="py-12 bg-white border-t border-slate-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-8">
          {/* Top row */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center">
                <Leaf style={{ width: 16, height: 16 }} className="text-emerald-600" aria-hidden="true" />
              </div>
              <span className="font-semibold text-slate-900">CynthIA</span>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500">
              <Link to="/blog" className="hover:text-emerald-600 transition-colors">
                Blog
              </Link>
              <Link to="/mentions-legales" className="hover:text-emerald-600 transition-colors">
                Mentions Légales
              </Link>
              <Link to="/cgv" className="hover:text-emerald-600 transition-colors">
                CGV
              </Link>
              <Link to="/politique-de-confidentialite" className="hover:text-emerald-600 transition-colors">
                Politique de Confidentialité
              </Link>
              <a href="mailto:contact@naturalinksmartgarden.fr" className="hover:text-emerald-600 transition-colors">
                Support
              </a>
            </div>
          </div>

          {/* Bottom row */}
          <div className="flex flex-col items-center gap-2">
            <span className="text-xs text-slate-400 font-medium tracking-wide">
              🇫🇷 Conçu & fabriqué en France — Chalon-sur-Saône
            </span>
            <p className="text-sm text-slate-400">© {new Date().getFullYear()} CynthIA. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
